export const GET_ALL_CATEGORY_LIST_REQUEST = "GET_ALL_CATEGORY_LIST_REQUEST";
export const GET_ALL_CATEGORY_LIST_SUCCESS = "GET_ALL_CATEGORY_LIST_SUCCESS";
export const GET_ALL_CATEGORY_LIST_ERROR = "GET_ALL_CATEGORY_LIST_ERROR";

export const GET_CALENDER_LIST_DATA_REQUEST = "GET_CALENDER_LIST_DATA_REQUEST";
export const GET_CALENDER_LIST_DATA_SUCCESS = "GET_CALENDER_LIST_DATA_SUCCESS";
export const GET_CALENDER_LIST_DATA_ERROR = "GET_CALENDER_LIST_DATA_ERROR";
